import { render, staticRenderFns } from "./DialogOneTask.vue?vue&type=template&id=761977a6&scoped=true"
import script from "./DialogOneTask.vue?vue&type=script&lang=js"
export * from "./DialogOneTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761977a6",
  null
  
)

export default component.exports